const css = require('./selected-user.css');
const UserForm = require('../../../common/user/user-form');
const Overlay = require('../../../layout/overlay');
let formatter = require('../../../../helpers/formatter');

class SelectedUser {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => {
            let fullName = formatter.fullName(data['selectedUser']);
            return Object.assign({}, data, { fullName }, { css });
        });
    }
}

module.exports = {
    constructor: SelectedUser,
    children: [
        {
            name: 'user-form',
            component: UserForm,
            props: {
                disableEditing: true
            },
            watcher: {
                userType: ['account', 'userForm', 'form', 'userType']
            }
        },
        {
            name: 'overlay',
            component: Overlay,
            watcher: {
                isLoading: ['account', 'users', 'selectedUserIsLoading']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/users/selected-user/index.js